import { css } from '@emotion/css/macro';
import Color from '../../../../common/Color';
import StyleConstants from '../../../../common/StyleConstants';

const style = css`
  max-width: ${StyleConstants.MAX_WIDTH}px;
  width: 100%;
  background-color: #e7ecf8;
  padding: 40px 0 40px;
  p {
    font-size: 42px;
    margin: 14px 0 0 25px;
    padding-bottom: 25px;
  }
  h1 {
    color: #4855d1;
    font-size: 22px;
    margin: 0 0 30px 25px;
    letter-spacing: -0.82px;
    line-height: 1.36;
    font-weight: bold;
  }
  #program1 {
    width: 55px;
    height: 91px;
    margin: -50px 0 0 27px;
  }
  #program2 {
    width: 107px;
    height: 69px;
    margin: -40px 0 -30px calc(100% - 134px);
  }
  #program3 {
    width: 159px;
    height: 126px;
    margin: -50px 0 0 27px;
  }
`;
const speechBalloonDescBox = css`
  width: 293px;
  height: 160px;
  margin: 15px 0;
  h3 {
    font-size: 20px;
    letter-spacing: -0.75px;
    color: ${Color.WHITE};
    padding: 20px 0 0 26px;
    line-height: 1.5;
    b {
      font-weight: bold;
    }
  }
  h4 {
    padding: 10px 0 0 26px;
    color: #d9d6d6;
    font-size: 16px;
    letter-spacing: -0.6px;
    line-height: 1.38;
    b {
      font-weight: bold;
    }
  }
`;
const rightBox = css`
  ${speechBalloonDescBox};
  border-radius: 25px 0 0 25px;
  margin-left: calc(100% - 293px);
  text-align-last: right;
  h3 {
    margin-right: 27px;
  }
  h4 {
    margin-right: 27px;
  }
`;
const leftBox = css`
  ${speechBalloonDescBox};
  left: 0;
  background: linear-gradient(230deg, #49bcf6 150%, #7e3efc 58%);
  border-radius: 0 25px 25px 0;
`;

export default function ProgramView() {
  return (
    <section className={style}>
      <p>🦑</p>
      <h1>
        도깃은 믿을 수 있는
        <br />
        프로그램인가요?
      </h1>
      <div className={rightBox} style={{ background: 'linear-gradient(141deg, #3bd2b1 59%, #686eda 118%, #c0dc88 119%)' }}>
        <h3>
          <b>5명의 전문가</b>
          가 만든
          <br />
          커리큘럼
        </h3>
        <h4 style={{ color: Color.WHITE }}>
          강아지 문제행동 전문가 5명의
          <br />
          자문을 통해 커리큘럼을 제작했어요.
        </h4>
      </div>
      <img id='program1' src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-program1.png' />
      <div className={leftBox} style={{ background: 'linear-gradient(230deg, #7e3efc 58%, #49bcf6 150%)' }}>
        <h3>
          일방향적인 훈련 영상 말고,
          <br />
          <b>우리 강아지를 위한 맞춤 훈련</b>
        </h3>
        <h4>
          훈련 후 강아지의 반응을 입력하면
          <br />
          강아지를 위한 맞춤 훈련법이 제시돼요.
        </h4>
      </div>
      <img id='program2' src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-program2.png' />
      <div className={rightBox} style={{ background: 'linear-gradient(207deg, #49bcf6 47%, #7a48fc 123%)' }}>
        <h3>
          <b>96% 보호자</b>의 개선 경험
        </h3>
        <h4 style={{ color: Color.WHITE }}>
          베타테스터 1만여 명 중, 96%가
          <br />
          도깃으로 '개선'을 경험했다고
          <br />
          응답했어요.
        </h4>
      </div>
      <img id='program3' src='//static.dogmate.co.kr/dogit/landing-v3/dogit-v3-program3.png' />
    </section>
  );
}
